<template>
  <ul v-if="visible && (items.length > 0 || showCreate)" class="autocomplete-dropdown" :class="{ 'is-drop-up': dropUp }">
    <li
      v-for="(item, index) in items"
      :key="item.id || item.name"
      class="autocomplete-item"
      :class="{ 'is-selected': index === selectedIndex }"
      @mousedown.prevent="$emit('select', item)"
      @mouseenter="$emit('hover', index)"
    >
      <span class="trigger-char">{{ triggerChar }}</span>{{ item.name }}
    </li>
    <li
      v-if="showCreate"
      class="autocomplete-item autocomplete-create"
      :class="{ 'is-selected': selectedIndex === items.length }"
      @mousedown.prevent="$emit('create')"
      @mouseenter="$emit('hover', items.length)"
    >
      Create <span class="trigger-char">{{ triggerChar }}</span><strong>{{ query }}</strong>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  items: { type: Array, default: () => [] },
  visible: { type: Boolean, default: false },
  triggerChar: { type: String, default: '@' },
  query: { type: String, default: '' },
  showCreate: { type: Boolean, default: false },
  selectedIndex: { type: Number, default: 0 },
  dropUp: { type: Boolean, default: false },
})

defineEmits(['select', 'create', 'hover'])
</script>

<style scoped>
.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 40;
  max-height: 200px;
  overflow-y: auto;
  background: var(--bulma-scheme-main);
  border: 1px solid var(--bulma-border);
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  list-style: none;
  margin: 0;
  padding: 4px 0;
}

.autocomplete-dropdown.is-drop-up {
  top: auto;
  bottom: 100%;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
}

.autocomplete-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.9rem;
}

.autocomplete-item:hover,
.autocomplete-item.is-selected {
  background: var(--bulma-scheme-main-bis);
}

.autocomplete-create {
  color: var(--bulma-link);
}

.trigger-char {
  opacity: 0.5;
  margin-right: 1px;
}
</style>
